module.exports = __webpack_public_path__ + "img/list-empty.59d3a7fb.png";